import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { ViewScore } from "./ViewScore";
import { t } from "i18next";
import { Score } from "@keita/lanepatrol-sdk";
import { CustomDialog } from "../../shared/views/CustomDialog";

interface Props {
  score: Score;
  showLabel?: boolean;
}

export const ScoringBubble: React.FC<Props> = ({
  score,
  showLabel = false,
}) => {
  const { open, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        onClick={(event) => {
          event.stopPropagation();
          onOpen();
        }}
        size="xs"
        fontSize={"sm"}
        className={`score risk ${score.global.riskFactor}`}
      >
        {showLabel
          ? t("coding:currentRating", {
              rating: score.global.value.toFixed(2),
            })
          : score.global.value.toFixed(3)}
      </Button>

      {open && (
        <CustomDialog size={"xl"} onClose={onClose} header={null}>
          <ViewScore score={score} />
        </CustomDialog>
      )}
    </>
  );
};
